class RegistrationForm {
	constructor(form) {
		this.form = form;
		this.typeSwitcher();
		this.registrationConditions();
		this.updatePaymentStepDisabled();
    this.checkVoivodshipValue();
	}

	typeSwitcher() {
		Array.from( this.form.querySelectorAll( '.type--switcher input[name="account-type"]' ) ).forEach(
			(radio) => {
            radio.addEventListener(
					'change',
					(event) => {
                    this.form.classList.remove( 'form--company', 'form--person' );
                    this.form.classList.add( 'form--' + event.currentTarget.id );
					}
				);
			}
		);
	}

	registrationConditions() {
		let selectAllCheckbox = document.getElementById( 'select-all' );
		if (selectAllCheckbox) {
			selectAllCheckbox.addEventListener(
				'change',
				(event) => {
                this.registrationConditionsSelect( selectAllCheckbox );
				}
			);
		}

		let checkboxes = this.form.querySelectorAll( '.registration-conditions input[type="checkbox"]' );
		Array.from( checkboxes ).forEach(
			(checkbox) => {
				checkbox.addEventListener(
          'change',
          () => {
            this.updatePaymentStepDisabled();
          }
        );
			}
		);

    let inputs = this.form.querySelectorAll( '.customer-data input[type="text"], .customer-data input[type="email"], .customer-data input[type="tel"], .customer-data select' );
		Array.from( inputs ).forEach(
			(input) => {
				input.addEventListener(
          'change',
          () => {
            setTimeout(() => {
              this.updatePaymentStepDisabled();
            }, 100);
          }
        );
			}
		);

    let types = this.form.querySelectorAll( '.type--switcher input[type="radio"]' );
		Array.from( types ).forEach(
			(radio) => {
				radio.addEventListener(
          'change',
          () => {
            this.updatePaymentStepDisabled();
          }
        );
			}
		);
	}


  

	registrationConditionsSelect(checkbox) {
		let conditions        = this.form.querySelectorAll( '.registration-conditions input[type="checkbox"]:not([id="' + checkbox.id + '"])' );
		Array.from( conditions ).forEach(
			(condition) => {
				condition.checked = checkbox.checked;
			}
		);

		this.updatePaymentStepDisabled();
	}

	updatePaymentStepDisabled() {
		let requiredCheckboxes = this.form.querySelectorAll( '.registration-conditions input[type="checkbox"][required]' );
		let requiredVoivodship = this.form.querySelector( '#billing_voivodeship' );
		let paymentStep        = document.getElementById( 'payment_methods_step' );
		let isDisabled         = Array.from( requiredCheckboxes ).some( (checkbox) => ! checkbox.checked );
		let voivodship         = true; 
		// Check if inputs are not empty. 
		const  requiredInputs = document.getElementById('checkout-customer').querySelectorAll('.form-row.validate-required input');

		// Check if inputs have value by default 
		let inputsHaveValue = !!!Array.from(requiredInputs).find((input) => {
			const inputContainer = input.closest('.form-row');
			const isHidden = window.getComputedStyle(inputContainer, null).display === 'none';
      const hasErrorClass = input.classList.contains('error');

      return (input.value.length === 0 && !isHidden) || (hasErrorClass && !isHidden);
		})


    if (requiredVoivodship.value === "") {
      voivodship = false;
    }

		if (!isDisabled && inputsHaveValue && voivodship) {
			paymentStep.classList.remove( 'disabled' );
			paymentStep.removeAttribute( 'disabled' );
		} else {
			paymentStep.classList.add( 'disabled' );
			paymentStep.setAttribute( 'disabled', 'disabled' );
		}
	}

  checkVoivodshipValue() {
    const voivodshipSelectElement = document.getElementById('billing_voivodeship');

    if(!voivodshipSelectElement) return; 
		[...voivodshipSelectElement.options].forEach(option => {
      if(!option.value && option.selected) {
        option.setAttribute('disabled', '');
        option.setAttribute('hidden', '')
        voivodshipSelectElement.classList.add('no-value')
      }

      voivodshipSelectElement.addEventListener('change', () => voivodshipSelectElement.classList.remove('no-value'))
    });
  }
}

let form = document.getElementById( 'user-form' );
if (form) {
	new RegistrationForm( form );
}
